<div id="selected-reservation">
    <div class="reservation">
        <div class="rev-header">
            <!-- <p class="subtitle">{{'event_reserv.subtitle' | translate}}</p> -->
            <h1 class="title">{{reservation.event_name[userLanguage] || reservation.event_name[languages.default]}}</h1>
        </div>
        <div class="rev-body">
            @for (rev of reservation.associated_reservations; track $index) {
                @if (!!rev.displayName) {
                    <div class="partecipante list">
                        <div class="title">{{'event_reserv.partecipante' | translate}}</div>
                        <div class="text">{{rev.displayName}}</div>
                    </div>
                }
                @if (!!rev.creation_datetime) {
                    <div class="data-creazione list">
                        <div class="title">{{'event_reserv.data_prenotazione' | translate}}</div>
                        <div class="text">{{rev.creation_datetime}}</div>
                    </div>
                }
                @if (!!rev.event_occurrence_datetime) {
                    <div class="data list">
                        <div class="title">{{'event_reserv.data_ora' | translate}}</div>
                        <div class="text">{{rev.event_occurrence_datetime}}</div>
                    </div>
                }
                @if (!!rev.is_waiting_list && rev.is_waiting_list == 1) {
                    <div class="status list">
                        <div class="title">{{'event_reserv.status' | translate}}</div>
                        <div class="text">{{'event_reserv.inwl' | translate}}</div>
                    </div>
                }

                @if (!!rev.is_waiting_list && rev.is_waiting_list == 0) {
                    <div class="status list">
                        <div class="title">{{'event_reserv.status' | translate}}</div>
                        <div class="text">{{'event_reserv.reservconf' | translate}}</div>
                    </div>
                }

                @if (userService.isEmployeeWithoutPassenger()) {
                    <div class="numero-passeggerri list">
                        <div class="title">{{'event_reserv.num_pass' | translate}}</div>
                        <div class="text">{{rev.number_of_users}}</div>
                    </div>
                }

                @if (rev.is_editable) {
                    <div class="buttons">
                        @if (rev.event_dates.length > 0) {
                            <button class="mini-button annulla" (click)="eventSelected(rev)">{{'edit'|translate}}</button>
                        }
                        <button class="mini-button conferma" (click)="showConfirmDelete(rev)">{{'edit_booking.delete_book'|translate}}</button>
                    </div>
                } @else {
                    <div class="no-buttons"></div>
                }
            }
        </div>
        <div class="rev-footer">
            <button class="my-button" (click)="goBack()">{{'close'|translate}}</button>
        </div>
    </div>
</div>
